import * as $runtime from "../runtime.js";
import * as Data$dCodePoint$dUnicode from "../Data.CodePoint.Unicode/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dString$dRegex from "../Data.String.Regex/index.js";
import * as Data$dString$dRegex$dFlags from "../Data.String.Regex.Flags/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing$dCombinators from "../Parsing.Combinators/index.js";
import * as Parsing$dString$dBasic from "../Parsing.String.Basic/index.js";
import * as Partial from "../Partial/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dDynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const replicateA = /* #__PURE__ */ Data$dUnfoldable.replicateA(Parsing.applicativeParserT)(Data$dUnfoldable.unfoldableArray)(Data$dTraversable.traversableArray);
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe))();
const whenJust = validate => value => Restaumatic$dForm$dDynamicResult.andThen(value)(v => {
  if (v.tag === "Nothing") { return Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure([]); }
  if (v.tag === "Just") { return validate(Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure(v._1)); }
  $runtime.fail();
});
const whenD = condD => validate => value => Restaumatic$dForm$dDynamicResult.andThen(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.applicativeResult.pure)(condD))(cond => {
  if (cond) { return validate(value); }
  return Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure([]);
});
const testRx = rxS => s => {
  const $0 = Data$dString$dRegex.regex(rxS)(Data$dString$dRegex$dFlags.noFlags);
  if ($0.tag === "Left") { return false; }
  if ($0.tag === "Right") { return Data$dString$dRegex.test($0._1)(s); }
  $runtime.fail();
};
const predValidate = msg => pred => Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(x => {
  const $0 = pred(x);
  if (!$0) { return []; }
  if ($0) { return [msg]; }
  $runtime.fail();
});
const postcodeValidate = /* #__PURE__ */ predValidate("Kod pocztowy to np. 25-437")(x => !testRx("^\\d{2}-\\d{3}$")(x));
const phoneNumber = /* #__PURE__ */ (() => {
  const $0 = Data$dString$dRegex.regex("\\D")(Data$dString$dRegex$dFlags.global);
  if ($0.tag === "Left") {
    const doesPhoneMatchRegex = Data$dString$dRegex.test((() => {
      const $1 = Data$dString$dRegex.regex("^\\+?[0-9 -]+$")(Data$dString$dRegex$dFlags.noFlags);
      if ($1.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($1._1)); }
      if ($1.tag === "Right") { return $1._1; }
      $runtime.fail();
    })());
    const $1 = Data$dString$dRegex.regex("\\+\\d{1,3}")(Data$dString$dRegex$dFlags.noFlags);
    const $2 = (() => {
      if ($1.tag === "Left") { return x => Data$dString$dCodePoints.toCodePointArray(x).length; }
      if ($1.tag === "Right") { return x => Data$dString$dCodePoints.toCodePointArray(Data$dString$dRegex.replace($1._1)("")(x)).length; }
      return x => {$runtime.fail();};
    })();
    return Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(s => {
      const $3 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.validations.invalid_phone), {})];
      const $4 = doesPhoneMatchRegex(s) && (() => {
        const $4 = $2(s);
        return $4 > 4 && $4 < 16;
      })()
        ? []
        : $3;
      if (Data$dString$dCommon.trim(s) === "") { return []; }
      return $4;
    });
  }
  if ($0.tag === "Right") {
    const doesPhoneMatchRegex = Data$dString$dRegex.test((() => {
      const $1 = Data$dString$dRegex.regex("^\\+?[0-9 -]+$")(Data$dString$dRegex$dFlags.noFlags);
      if ($1.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($1._1)); }
      if ($1.tag === "Right") { return $1._1; }
      $runtime.fail();
    })());
    const $1 = Data$dString$dRegex.regex("\\+\\d{1,3}")(Data$dString$dRegex$dFlags.noFlags);
    const $2 = (() => {
      if ($1.tag === "Left") { return x => Data$dString$dCodePoints.toCodePointArray(Data$dString$dRegex.replace($0._1)("")(x)).length; }
      if ($1.tag === "Right") { return x => Data$dString$dCodePoints.toCodePointArray(Data$dString$dRegex.replace($0._1)("")(Data$dString$dRegex.replace($1._1)("")(x))).length; }
      return x => {$runtime.fail();};
    })();
    return Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(s => {
      const $3 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.validations.invalid_phone), {})];
      const $4 = doesPhoneMatchRegex(s) && (() => {
        const $4 = $2(s);
        return $4 > 4 && $4 < 16;
      })()
        ? []
        : $3;
      if (Data$dString$dCommon.trim(s) === "") { return []; }
      return $4;
    });
  }
  const doesPhoneMatchRegex = Data$dString$dRegex.test((() => {
    const $1 = Data$dString$dRegex.regex("^\\+?[0-9 -]+$")(Data$dString$dRegex$dFlags.noFlags);
    if ($1.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($1._1)); }
    if ($1.tag === "Right") { return $1._1; }
    $runtime.fail();
  })());
  const $1 = Data$dString$dRegex.regex("\\+\\d{1,3}")(Data$dString$dRegex$dFlags.noFlags);
  const $2 = (() => {
    if ($1.tag === "Left") { return x => {$runtime.fail();}; }
    if ($1.tag === "Right") { return x => {$runtime.fail();}; }
    return x => {$runtime.fail();};
  })();
  return Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(s => {
    const $3 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.validations.invalid_phone), {})];
    const $4 = doesPhoneMatchRegex(s) && (() => {
      const $4 = $2(s);
      return $4 > 4 && $4 < 16;
    })()
      ? []
      : $3;
    if (Data$dString$dCommon.trim(s) === "") { return []; }
    return $4;
  });
})();
const parseTenDigits = s => {
  const $0 = Parsing.runParserT1(s)((() => {
    const $0 = replicateA(10)(Parsing$dCombinators.withErrorMessage(Parsing$dString$dBasic.satisfyCP(Data$dCodePoint$dUnicode.isDecDigit))("digit"));
    return (state1, more, lift1, $$throw, done) => more(v1 => $0(
      state1,
      more,
      lift1,
      $$throw,
      (state2, a) => more(v2 => done(
        state2,
        (() => {
          const $1 = traverse(x => Data$dInt.fromString(Data$dString$dCodeUnits.singleton(x)))(a);
          if ($1.tag === "Just") {
            if ($1._1.length > 0) { return Data$dMaybe.$Maybe("Just", $1._1); }
            return Data$dMaybe.Nothing;
          }
          if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
          $runtime.fail();
        })()
      ))
    ));
  })());
  if ($0.tag === "Left") { return Data$dMaybe.Nothing; }
  if ($0.tag === "Right") { return $0._1; }
  $runtime.fail();
};
const number = /* #__PURE__ */ (() => {
  const doesNumberMatchRegex = Data$dString$dRegex.test((() => {
    const $0 = Data$dString$dRegex.regex("^[0-9]+$")(Data$dString$dRegex$dFlags.noFlags);
    if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
    if ($0.tag === "Right") { return $0._1; }
    $runtime.fail();
  })());
  return Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(s => {
    const $0 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.validations.invalid_number), {})];
    const $1 = doesNumberMatchRegex(s) ? [] : $0;
    if (Data$dString$dCommon.trim(s) === "") { return []; }
    return $1;
  });
})();
const notNothing = /* #__PURE__ */ (() => Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(a => {
  const $0 = (() => {
    if (a.tag === "Nothing") { return true; }
    if (a.tag === "Just") { return false; }
    $runtime.fail();
  })();
  const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
}))();
const nonEmptySet = /* #__PURE__ */ (() => Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(v => {
  const $0 = v.tag === "Leaf";
  const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
}))();
const nonEmpty = dictEq => dictMonoid => {
  const mempty1 = dictMonoid.mempty;
  return Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(a => {
    const $0 = dictEq.eq(a)(mempty1);
    const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
    if (!$0) { return []; }
    if ($0) { return $1; }
    $runtime.fail();
  });
};
const lessThan = dictOrd => dictShow => msg => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    if (dictOrd.compare(value)(threshold).tag === "LT") { return []; }
    return [msg];
  })(a))(b);
};
const inRange = range => Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(a => {
  const $0 = a < range.min || a > range.max;
  const $1 = [
    Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.validations.invalid_range),
      {min: Data$dShow.showIntImpl(range.min), max: Data$dShow.showIntImpl(range.max)}
    )
  ];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
});
const greaterThan = dictOrd => dictShow => msg => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    if (dictOrd.compare(value)(threshold).tag === "GT") { return []; }
    return [msg];
  })(a))(b);
};
const email = /* #__PURE__ */ (() => {
  const doesEmailMatchRegex = Data$dString$dRegex.test((() => {
    const $0 = Data$dString$dRegex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data$dString$dRegex$dFlags.noFlags);
    if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
    if ($0.tag === "Right") { return $0._1; }
    $runtime.fail();
  })());
  return Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(s => {
    const $0 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.validations.invalid_email), {})];
    const $1 = doesEmailMatchRegex(s) ? [] : $0;
    if (Data$dString$dCommon.trim(s) === "") { return []; }
    return $1;
  });
})();
export {
  email,
  greaterThan,
  inRange,
  lessThan,
  nonEmpty,
  nonEmptySet,
  notNothing,
  number,
  parseTenDigits,
  phoneNumber,
  postcodeValidate,
  predValidate,
  replicateA,
  testRx,
  traverse,
  whenD,
  whenJust
};
